"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolFailure = exports.recordedOutcomeOf = exports.outcomeMessageOf = exports.needsInput = exports.isToolNeedsInput = exports.isToolFailure = exports.NEEDS_INPUT = void 0;
const toolFailure = (error, message) => ({ error, message });
exports.toolFailure = toolFailure;
const isToolFailure = (value) => typeof value?.error === 'string';
exports.isToolFailure = isToolFailure;
const NEEDS_INPUT = 'needs_input';
exports.NEEDS_INPUT = NEEDS_INPUT;
const needsInput = (message, options) => (options === undefined ?
    { outcome: NEEDS_INPUT, message } :
    { outcome: NEEDS_INPUT, message, options });
exports.needsInput = needsInput;
const isToolNeedsInput = (value) => typeof value === 'object' && value !== null &&
    value.outcome === NEEDS_INPUT &&
    typeof value.message === 'string';
exports.isToolNeedsInput = isToolNeedsInput;
const recordedOutcomeOf = (output) => isToolNeedsInput(output) ? NEEDS_INPUT : undefined;
exports.recordedOutcomeOf = recordedOutcomeOf;
const outcomeMessageOf = (output) => isToolNeedsInput(output) ? output.message : '';
exports.outcomeMessageOf = outcomeMessageOf;
//# sourceMappingURL=result.js.map